// Module
var code = "<div class=\"gc-fake-step\"></div>";
// Exports
export default code;